import InitApi from "api/InitApi";
import { deleteEmptyObjects, fetchConfig } from "utils";
import { useQuery } from "react-query";
import useTokenStore from "store/tokenStore";

const useFetchAuditTrail = (queryParams, shouldFetch = true) => {
	const { accessToken } = useTokenStore();

	const fetch = async () => {
		const instance = await InitApi({ accessToken });
		const params = queryParams ? deleteEmptyObjects(queryParams) : null;
		const response = await instance.get("/audit-trail", { params });
		return response?.data;
	};

	return useQuery(["audit-trail", queryParams], () => fetch(), {
		...fetchConfig,
		enabled: shouldFetch,
		keepPreviousData: true,
	});
};

export default useFetchAuditTrail;
